<div class="w-100 py-1">
    <div class="d-flex flex-wrap justify-content-center">
        <!-- <div class="w-100 d-flex justify-content-center flex-wrap">
            <button class="btn btn-outline-primary" [disabled]="transactionService.isConnectedWallet" (click)="connectWallet()">
                {{ transactionService.isConnectedWallet ? 'Connected' : 'Connect to wallet'}}
            </button>
            <span *ngIf="transactionService.isConnectedWallet" class="w-100 text-center py-1">Your wallet address : {{transactionService.connectedWalletAddress}}</span>
            <span *ngIf="!transactionService.isConnectedWallet" class="w-100 text-center py-1">You will be popped up with a qr code, scan with suitable wallet to proceed.</span>
        </div> -->
        <div class="w-100 d-flex justify-content-center flex-wrap align-items-center py-1 text-white" *ngIf="transactionService.isConnectedWallet && +transactionService.balance>=0" >
            <!-- <button class="btn btn-outline-success" *ngIf="transactionService.isConnectedWallet" (click)="checkBalance()">
                Check balance
            </button> -->
            <span class="text-center py-1">
                Your wallet balance : {{transactionService.balance}} {{transactionService.source}}
                
            </span>
            <mat-icon aria-hidden="false" aria-label="Example home icon" class="m-1 cursor-pointer" (click)="checkBalance()">refresh</mat-icon>
        </div>
        <div class="w-100 d-flex justify-content-center flex-wrap py-1">
            <button class="btn btn-outline-light" *ngIf="transactionService.isConnectedWallet" (click)="disconnectWallet()">
                Disconnect wallet
            </button>
        </div>
        <div class="w-100 d-flex justify-content-center m-1">
            <div class="col-12 col-md-10 p-3 rounded-more text-white bg-without" style="box-shadow:0 0.75em 1.5em rgba(0,0,0,0.75);">
                <div class="text-center font-inter-bold w-100 py-2 ">
                    Swap
                    <!-- Stable coins to Fiat.<br /> -->
                    <!-- <span style="font-weight: 100;">Made Easy!</span> -->
                </div>
                <div class="input-group mb-3">
                    <input type="number" class="form-control" placeholder="Source amount" aria-label="Source amount" aria-describedby="basic-addon2" [(ngModel)]="transactionService.sourceAmount" (input)="changeDestinationAmount()">
                    <!-- <div class=" input-group-append btn-group">
                        <button type="button" class="btn btn-outline-primary" disabled>
                            cUSD
                        </button>
                    </div>  -->
                    <button type="button" class="btn btn-outline-light dropdown-toggle rounded text-left" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img [src]="sourceUrl"  class="mx-2" style="width:16px !important">
                        {{transactionService.source}}
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" *ngFor="let source of transactionService.sources" (click)="selectSource(source, source.image.url)">
                            <img [src]="source.image.url"  [alt]="source.name" class="mx-2" style="width:16px !important">
                            {{source.name}}
                        </a>
                    </div>
                </div>
                <div class="pb-3 d-flex justify-content-between px-2">
                    <span *ngIf="transactionService.source" class="font-inter-light">
                        {{transactionService.fees}} <span class="text-white">{{transactionService.source}}</span>
                    </span>
                    <span class="font-inter-light">
                        Fees charged  
                    </span>
                </div>
                <div class="pb-3 d-flex justify-content-between px-2">
                    <span *ngIf="transactionService.source" class="font-inter-light">
                        1 <span class="text-white">{{transactionService.source}}</span> =  {{transactionService.conversionRate}} <span class="text-white">{{beneficiaryService.selectedDestination?.name}}</span>
                        <!-- {{transactionService.conversionRate}} <span class="text-primary">{{source}}</span> to <span class="text-success">{{beneficiaryService.selectedDestination.name}}</span> -->
                    </span>
                    <span class="font-inter-light">
                        Conversion rate
                    </span>
                </div>
                <div class="input-group mb-3">
                    <input type="number" class="form-control" placeholder="Destination amount" aria-label="Destination amount" aria-describedby="basic-addon2" [(ngModel)]="transactionService.convertedAmount" readonly>
                    <div class=" input-group-append btn-group">
                        <button type="button" class="btn btn-outline-light" disabled>
                            {{beneficiaryService.selectedDestination?.name}}
                        </button>
                    </div> 
                </div>
                <div class="input-group mb-3">
                    <button class="btn btn-outline-light mx-auto" (click)="createTransaction()" [disabled]="!this.transactionService.isConnectedWallet || !this.beneficiaryService.selectedBeneficiary || !transactionService.sourceAmount || !transactionWithinLimits()" style="white-space:break-spaces">
                        Send {{this.beneficiaryService.selectedBeneficiary ? 'money to '+this.beneficiaryService.selectedBeneficiary.name : ''}} now!
                    </button>
                    <span class="text-white text-center w-100" *ngIf="this.transactionService.isConnectedWallet && this.beneficiaryService.selectedBeneficiary && transactionService.sourceAmount && !transactionWithinLimits()">
                        You can only send less than {{transactionService.upper_limit}} {{beneficiaryService.selectedDestination?.name}} and more than {{transactionService.lower_limit}} {{beneficiaryService.selectedDestination?.name}}.
                    </span>
                    <span class="text-white text-center w-100" *ngIf="transactionService.transactionInitiated">Kindly approve transaction in your wallet.</span>
                    <span class="text-white text-center w-100" *ngIf="transactionService.gasFeesError">Wallet charges around 0.05cUSD as gas fees. Insufficient funds.</span>
                </div>
            </div>
        </div>
    </div>
</div>